/* eslint-disable max-len */

import type { MessageSchema } from '@/i18n/types';

const kk: MessageSchema['layout'] = {
    header: {
        leadsBalance: 'Лидтер балансы',
        refill:       'Толықтыру',
    },
    nav: {
        help:       'Көмек',
        leads:      'Лидтер',
        statistics: 'Статистика',
    },
    profile: {
        logout: 'Шығу',
    },
    report: {
        download:        'Есепті жүктеп алу',
        generationError: 'Есепті жасау кезінде қате шықты, қайта байқап көріңіз немесе кейінірек әрекет етіңіз',
        minPeriod:       'Есептің ең аз кезеңі – бір апта',
        title:           'Аналитикалық есепті жүктеп алу',
    },
};

export default kk;
